var _a;
var FORM_FIELDS = {
    AMOUNT: 'amount',
    PERIOD: 'period',
    PURPOSE: 'purpose',
};
var FORM_FIELDS_LABELS_CONFIG = (_a = {},
    _a[FORM_FIELDS.AMOUNT] = { text: 'Сумма кредита', required: true },
    _a[FORM_FIELDS.PERIOD] = { text: 'На какой срок', required: true },
    _a[FORM_FIELDS.PURPOSE] = { text: 'Цель кредита', required: true },
    _a);

export { FORM_FIELDS, FORM_FIELDS_LABELS_CONFIG };
//# sourceMappingURL=form.js.map
